/**
 *  AudioParams
 *  Created by Legman on 25/02/2016.
 */
"use strict";

export default class AudioParams {
    constructor() {
        /**
         * @type {number}
         */
        this._volume = 1.0;

        /**
         * @type {boolean}
         */
        this._loop = false;

        /**
         * @type {number}
         */
        this._delay = 0.0;

        /**
         * @type {number}
         */
        this._fadeIn = 0.0;

        /**
         * @type {number}
         */
        this._priority = 0;

        /**
         * @type {function}
         */
        this._callback = null;

        /**
         * @type {*}
         */
        this._scope = window;
    }

    get volume() {
        return this._volume;
    }

    set volume(val) {
        this._volume = val;
    }

    get loop() {
        return this._loop;
    }

    set loop(val) {
        this._loop = val;
    }

    get delay() {
        return this._delay;
    }

    set delay(val) {
        this._delay = val;
    }

    get fadeIn() {
        return this._fadeIn;
    }

    set fadeIn(val) {
        this._fadeIn = val;
    }

    get priority() {
        return this._priority;
    }

    set priority(val) {
        this._priority = val;
    }

    get callback() {
        return this._callback;
    }

    set callback(val) {
        this._callback = val;
    }

    get scope() {
        return this._scope;
    }
}

